import { FC, useEffect } from 'react';

import config from 'config';
import Button from 'components/_core/Button';

import NewMessageIndicator from './components/NewMessageIndicator';
import locales from './locales';
import initCanny from './utils/initSDK';

// https://developers.canny.io/install/changelog

const CannyChangelogButton: FC = () => {
  useEffect(() => {
    initCanny();

    if (window.Canny) {
      window.Canny('initChangelog', {
        align: 'bottom',
        appID: config.cannyAppId,
        position: 'right',
      });
    }
  }, []);

  return (
    <Button
      data-canny-changelog
      icon="sparkle-single"
      iconPosition="left"
      isExpanded={false}
      marginLeft="space-8"
      onClick={() => {}}
      size="sm"
      variant="discreet"
    >
      <NewMessageIndicator />
      {locales.text}
    </Button>
  );
};

export default CannyChangelogButton;
